import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core-react/i18n';

import type { PartialComment as PartialCommentForReport } from '#src/app/shared/components/abuse';
import { ReportAbuseLink } from '#src/app/shared/components/abuse';

import type { PartialComment } from './hooks/useCommentReportAbuse';
import { useCommentReportAbuse } from './hooks/useCommentReportAbuse';

type Props = {
	comment: PartialCommentForReport & PartialComment;
	petition: {
		id: string;
		slug: string;
	};
	size?: 'x-small' | 'small' | 'medium' | 'large' | 'x-large';
	className?: string;
};

export const CommentReportAbuse: React.FC<Props> = ({ comment, petition, size, className }) => {
	const {
		data: { a11yLabel },
	} = useCommentReportAbuse(comment);

	return (
		<div className={cn('flex items-center', className)}>
			<ReportAbuseLink type="comment" comment={comment} petitionId={petition.id} petitionSlug={petition.slug}>
				<button type="button" className="cursor-pointer border-none bg-transparent p-0" aria-label={a11yLabel}>
					<Text as="div" variant="body" size={size}>
						<Translate value="fe.components.comments.report" />
					</Text>
				</button>
			</ReportAbuseLink>
		</div>
	);
};
